import styled from 'styled-components';

import StartCryptoBG from '../../assets/images/StartCryptoBG.webp';
import StartCryptoBGMobile from '../../assets/images/StartCryptoBGMobile.webp';

export const Container = styled.div`
  background-image: url(${StartCryptoBG});
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 100vh;
  @media (max-width: 600px) {
    background-image: url(${StartCryptoBGMobile});
    background-size: 310%;
    background-position: right -450px top 50px;
  }
`;
